import { RequestService, type RequestOptions } from '../request-service';
import { ManagedApps } from './managed-apps';
import {
  ComponentType,
  type ManagedAppsRequest,
  type ManagedAppsResponse,
} from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';
import type RpcModule from '@wix/ambassador-devcenter-managedapps-v1-managed-app/rpc';
import type HttpModule from '@wix/ambassador-devcenter-managedapps-v1-managed-app/http';

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class ManagedAppsService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-devcenter-managedapps-v1-managed-app/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import('@wix/ambassador-devcenter-managedapps-v1-managed-app/http');
  }

  public async get(payload: ManagedAppsRequest, options?: RequestOptions) {
    const response = await this.request<
      ManagedAppsRequest,
      ManagedAppsResponse
    >({
      methodName: 'managedApps',
      payload: {
        ...payload,
        componentType: [
          ComponentType.WIDGET,
          ComponentType.WIDGET_OUT_OF_IFRAME,
          ComponentType.WEB,
          ComponentType.CUSTOM_ELEMENT_WIDGET,
          ComponentType.PLATFORM,
          ComponentType.EDITOR_ADDON,
          ComponentType.EDITOR_REACT_COMPONENT,
          ComponentType.STUDIO,
          ComponentType.STUDIO_WIDGET,
          ComponentType.PAGE,
          ComponentType.PAGE_OUT_OF_IFRAME,
          ComponentType.UNIFIED_PAGE,
          ComponentType.BACK_OFFICE_PAGE,
          ComponentType.DASHBOARD,
          ComponentType.MULTIPLE_DASHBOARDS,
        ],
      },
      options,
    });
    return new ManagedApps(response.managedApps || []);
  }
}
